import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'

import { useTranslation } from 'react-i18next'
import QuoteForm from './quote_form'

const QuoteModule = (props) => {
  const {
    config,
    machine,
    status
  } = props

  const [current, send] = machine
  const { context } = current
  const { i18n } = useTranslation()

  const formName = props.formName.toUpperCase()
  const quote = context?.quote_values

  const places =
    config?.product?.purchase_info?.places || []

  const accommodation =
    config?.product?.purchase_info?.accommodation

  const setForm = (form) => {
    send({
      type: props.formName.toUpperCase() + '_CHANGE',
      form
    })
  }

  const getLocationName = (location) => {
    if (!location) return ''

    if (location.type === 'airport') {
      const place = places.find(
        (place) =>
          place.code === location.code ||
          place.value === location.value
      )

      return (
        place?.name ||
        place?.label ||
        location.code ||
        location.value ||
        ''
      )
    }

    if (location.type === 'accommodation') {
      return (
        accommodation?.name ||
        accommodation?.label ||
        location.code ||
        location.value ||
        ''
      )
    }

    return (
      location.name ||
      location.label ||
      location.code ||
      location.value ||
      ''
    )
  }

  const pickupName = getLocationName(quote?.pickup)
  const dropoffName = getLocationName(quote?.dropoff)

  const tripTypeLabel =
    quote?.trip_type === 'round_trip'
      ? i18n.t('axis_quote_form.round_trip')
      : ''

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed'
            ? send(
                `REOPEN_${formName}STEP`
                  .replace('_FORM', '')
              )
            : null
        }
      >
        <span>
          <i
            className="fa fa-map-marker me-2"
            aria-hidden="true"
          />

          {status === 'completed' ? (
            <strong className="d-inline-flex align-items-center gap-2">
              <span>{pickupName}</span>

              <i
                className="fas fa-arrow-right"
                aria-hidden="true"
              />

              <span>{dropoffName}</span>

              {tripTypeLabel && (
                <span className="fw-normal text-body-secondary">
                  ({tripTypeLabel})
                </span>
              )}
            </strong>
          ) : (
            i18n.t('axis_quote_module.title')
          )}
        </span>
      </ModuleHeader>

      <ModuleBody
        status={status}
        className="
          p-3
          border
          rounded-bottom
          d-flex
          justify-content-center
        "
      >
        <QuoteForm
          step={props.formName}
          setForm={setForm}
          config={config}
          machine={machine}
        />
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default QuoteModule
